var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditRetirementAge = function SvgEditRetirementAge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35.102,
    height: 35,
    x: 0.917,
    y: 0.974,
    fill: "#848484",
    rx: 17.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m23.287 11.031 2.398 2.39m-.856-4.496-6.485 6.466a2.4 2.4 0 0 0-.657 1.222l-.599 2.99 2.999-.599c.464-.092.89-.32 1.225-.654l6.485-6.465a2.09 2.09 0 0 0-1.484-3.572 2.1 2.1 0 0 0-1.484.612"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M26.147 21.86v3.388c0 .599-.238 1.173-.663 1.596s-1 .662-1.601.662H11.427c-.6 0-1.176-.238-1.601-.662a2.26 2.26 0 0 1-.663-1.596v-12.42c0-.598.238-1.173.663-1.596s1-.662 1.601-.662h3.397"
  })));
};
export { SvgEditRetirementAge as ReactComponent };
export default __webpack_public_path__ + "images/edit-retirement-age.svg";